import { SortingState } from '@tanstack/react-table';
import { AdminCountriesFilterDto } from '@repo/common-types';

export interface CountriesFilterLocal extends Omit<AdminCountriesFilterDto, 'hasSubdivisions'> {
  hasSubdivisions?: boolean | '';
}

export interface CountriesQueryState {
  filter: CountriesFilterLocal;
  sorting: SortingState;
  skip: number;
  take: number;
}

export const initialState: CountriesQueryState = {
  filter: {},
  sorting: [],
  skip: 0,
  take: 25,
};

export type CountriesQueryAction =
  | { type: 'SET_FILTERS'; payload: CountriesFilterLocal }
  | { type: 'SET_SORTING'; payload: SortingState }
  | { type: 'SET_PAGINATION'; payload: { skip: number; take: number } }
  | { type: 'SET_SEARCH'; payload: string }
  | { type: 'RESET_FILTERS' };

export const queryReducer = (state: CountriesQueryState, action: CountriesQueryAction): CountriesQueryState => {
  switch (action.type) {
    case 'SET_FILTERS':
      return {
        ...state,
        filter: action.payload,
        skip: 0, // Reset to first page when filters change
      };
    case 'SET_SORTING':
      return {
        ...state,
        sorting: action.payload,
      };
    case 'SET_PAGINATION':
      return {
        ...state,
        skip: action.payload.skip,
        take: action.payload.take,
      };
    case 'SET_SEARCH':
      return {
        ...state,
        filter: {
          ...state.filter,
          search: action.payload,
        },
        skip: 0, // Reset to first page when search changes
      };
    case 'RESET_FILTERS':
      return {
        ...state,
        filter: {},
        skip: 0,
      };
    default:
      return state;
  }
};
